import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {animate, keyframes, query, sequence, state, style, transition, trigger} from '@angular/animations';
import {VideoPlayerComponent} from '../video-player/video-player.component';
import {LocationServiceService} from '../location-service.service';
import {GoogleMap} from '@angular/google-maps';
import {GamePromptService} from '../game-prompt.service';
import {faMagic, faTimes} from '@fortawesome/free-solid-svg-icons';
import {StateManagerService} from '../state-manager.service';
import {MapType} from '@angular/compiler';

@Component({
  selector: 'app-section2',
  templateUrl: './section2.component.html',
  styleUrls: ['./section2.component.css'],
  animations: [
    trigger('fadeOutTrigger', [
      // ...
      state('shown', style({
        opacity: 1,
        'z-index': 100
      })),
      state('hidden', style({
        opacity: 0,
        'z-index': -1
      })),
      transition('* => hidden', [
        animate('1s')
      ]),
      transition('* => shown', []),
      transition(':enter', [
        style({
          opacity: 0
        })
      ])
    ]),
    trigger('shakeit', [
      state('shakestart', style({
        transform: 'scale(1)',
      })),
      state('shakeend', style({
        transform: 'scale(1)',
      })),
      transition('shakestart => shakeend', animate('1000ms ease-in', keyframes([
        style({transform: 'translate3d(-1px, 0, 0)', offset: 0.1}),
        style({transform: 'translate3d(2px, 0, 0)', offset: 0.2}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.3}),
        style({transform: 'translate3d(4px, 0, 0)', offset: 0.4}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.5}),
        style({transform: 'translate3d(4px, 0, 0)', offset: 0.6}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.7}),
        style({transform: 'translate3d(2px, 0, 0)', offset: 0.8}),
        style({transform: 'translate3d(-1px, 0, 0)', offset: 0.9}),
      ]))),
    ]),
    trigger('quickFadeIn', [
      // ...
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({
        opacity: 0,
        display: 'none'
      })),
      transition('* => open', [
        animate('200ms', keyframes([
          style({display: 'block'}),
          style({opacity: 0}),
          style({opacity: 1})
        ]))
      ]),
      transition('void => closed', []),
      transition('open => closed', [
        animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0}),
          style({display: 'none'})
        ])),
      ]),
      transition(':enter', [
        style({
          opacity: 0,
          display: 'none'
        })
      ])
    ]),

    trigger('awardLetterTrigger', [
      state('notAwarded', style({
        opacity: 0,
        display: 'none'
      })),
      state('awarded', style({
        opacity: 0,
        display: 'none',
        transform: 'rotate(0)scale(0.1)', top: -63,
        left: -88,
      })),
      transition(':enter', [
        style({
          opacity: 0,
          display: 'none'
        })
      ]),
      transition('* => awarded', [
        sequence([
          style({display: 'block', transform: 'translate(-50%,-50%)rotate(0deg)'}),
          animate('500ms', style({})),
          animate('200ms', style({opacity: 1, transform: 'translate(-50%,-50%)rotate(10deg)'})),
          animate('200ms', style({transform: 'translate(-50%,-50%)rotate(-10deg)'})),
          animate('200ms', style({opacity: 1, transform: 'translate(-50%,-50%)rotate(10deg)'})),
          animate('200ms', style({transform: 'translate(-50%,-50%)rotate(-10deg)'})),
          animate('200ms', style({transform: 'translate(-50%,-50%)rotate(0deg)'})),
          animate('2000ms'),
          animate('500ms', style({
            transform: 'rotate(0)scale(0.1)', top: -63,
            left: -88
          })),
          query('.wand', [
            sequence([
              style({transform: 'rotate(0deg)'}),
              animate('200ms', style({opacity: 1, transform: 'translate(-50%,-50%)rotate(10deg)'})),
              animate('200ms', style({transform: 'translate(-50%,-50%)rotate(-10deg)'})),
              animate('200ms', style({transform: 'translate(-50%,-50%)rotate(10deg)'})),
              animate('200ms', style({transform: 'translate(-50%,-50%)rotate(-10deg)'})),
              animate('200ms', style({transform: 'translate(-50%,-50%)rotate(0deg)'})),


            ])
          ], {optional: true})
        ])
      ])
    ])
  ]
})
export class Section2Component implements AfterViewInit {
  guess: string;
  sectionId;
  locationId;
  passwordPopupState = 'hidden';
  sectionPopupState = 'hidden';
  scanPopupState = 'shown';
  wandPopupState = 'closed';
  letterAward = 'notAwarded';

  states = {};

  magic = faMagic;
  close = faTimes;

  @ViewChild('map') map: GoogleMap;


  center: google.maps.LatLngLiteral;
  mapCenter: google.maps.LatLngLiteral;
  nextLocation: google.maps.LatLngLiteral;
  zoom = 15;

  public currentLocationOptions: google.maps.MarkerOptions = {
    icon: {
      path: google.maps.SymbolPath.CIRCLE,
      fillOpacity: 0.5,
      fillColor: '#273999',
      strokeOpacity: 1.0,
      strokeColor: '#4a87e7',
      strokeWeight: 3.0,
      scale: 8
    }
  };

  public pathOptions: google.maps.PolylineOptions = {
    strokeColor: '#ff0d3a'
  };

  SATELLITE = google.maps.MapTypeId.SATELLITE;

  public options: google.maps.MapOptions = {
    styles: [
      {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
      {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
      {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{color: '#d56363'}],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{color: '#d56363'}],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{color: '#263c3f'}],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{color: '#6b9a76'}],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{color: '#38414e'}],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{color: '#212a37'}],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{color: '#9ca5b3'}],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{color: '#746855'}],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{color: '#1f2835'}],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{color: '#f3d19c'}],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{color: '#2f3948'}],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{color: '#d56363'}],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{color: '#17263c'}],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{color: '#515c6d'}],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{color: '#17263c'}],
      },
    ]
  };

  @ViewChild('playerComponent') player: VideoPlayerComponent;

  letterToAward = null;

  constructor(private route: ActivatedRoute, public promptService: GamePromptService, private stateManager: StateManagerService, private router: Router, private locationService: LocationServiceService) {
    this.states['passwordUnlockText'] = 'shakestart';
  }

  shakeMe(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
    this.states[stateVar] = 'shakeend';
  }

  ngAfterViewInit(): void {


    this.route.params.subscribe(value => {
      this.passwordPopupState = (value.sectionId && value.sectionId > 1) ? 'shown' : 'hidden';
      if (this.passwordPopupState === 'hidden') {
        console.log('PLay video section 2');
        this.player.playVideo();
      }

      this.locationId = parseInt(value.locationId);
      this.sectionId = parseInt(value.sectionId);

      this.nextLocation = this.locationService.getNextLocation(this.locationId, this.sectionId);
      this.mapCenter = this.nextLocation;

    });


    navigator.geolocation.getCurrentPosition((position) => {

      this.mapCenter = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });

    navigator.geolocation.watchPosition((position) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    }, positionError => {
    }, {enableHighAccuracy: true});

  }

  refreshLocation(): void {
    navigator.geolocation.getCurrentPosition((position) => {

      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });

  }

  videoEnded(): void {
    // The video stopped playing and fullscreen closed.
    console.log('video ended');
    this.sectionPopupState = 'shown';

    // Check if we need to award a letter.

    if (this.promptService.doesAwardLetter(this.sectionId)) {
      this.letterToAward = this.promptService.getLetter(this.sectionId);
      this.letterAward = 'awarded';
      this.stateManager.awardLetter(this.letterToAward);
    }
  }

  tryGuess(): void {

    if (this.promptService.checkSectionPassword(this.sectionId, this.guess)) {
      this.player.playVideo();
      this.passwordPopupState = 'hidden';
    } else {
      this.shakeMe('passwordUnlockText');
    }

  }


  haversine_distance(mk1: google.maps.LatLngLiteral, mk2: google.maps.LatLngLiteral): number {

    if (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('.web.app') > -1 || window.location.host.indexOf('10.68.') > -1) {
      return 0;
    }

    if (!mk1 || !mk2) {
      return 10000;
    }
    const R = 3958.8; // Radius of the Earth in miles
    const rlat1 = mk1.lat * (Math.PI / 180); // Convert degrees to radians
    const rlat2 = mk2.lat * (Math.PI / 180); // Convert degrees to radians
    const difflat = rlat2 - rlat1; // Radian difference (latitudes)
    const difflon = (mk2.lng - mk1.lng) * (Math.PI / 180); // Radian difference (longitudes)

    return (2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2)
      + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)))) * 1609.34;

  }

  openWandPopup(): void {
    this.wandPopupState = 'open';
  }

  closeWandPopup(): void {
    this.wandPopupState = 'closed';
  }


  hasLetter(letter): boolean {
    return this.stateManager.hasLetter(letter);
  }

}
